import { mapGetters } from "vuex";
import pageWrap from "../page-wrap/index.vue";
import SimpleBreadcrumbs from "@/modules/pages/components/simple-breadcrumbs/index.vue";

export default {
  name: "page-main",
  components: {
    pageWrap,
    SimpleBreadcrumbs
  },
  computed: {
    ...mapGetters({
      page: "pages/page",
      pagesLoading: "pages/pagesLoading",
      headerMenu: "setting/headerMenu",
    }),
  },
};
